"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.saveCurrentAccountData = exports.loadCurrentAccountData = exports.initiatePasswordReset = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _cicUtils = require("@eon-funke/cic-utils");
var _accountDataApi = require("../api/accountDataApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_ACCOUNT_DATA = 'api/reducer/GET_ACCOUNT_DATA';
var SAVE_ACCOUNT_DATA = 'api/reducer/SAVE_ACCOUNT_DATA';
var INITIATE_PASSWORD_RESET = 'api/reducer/INITIATE_PASSWORD_RESET';
var INITIATE_PASSWORD_RESET_DONE = 'api/reducer/INITIATE_PASSWORD_RESET_DONE';
var INITIATE_PASSWORD_RESET_ERROR = 'api/reducer/INITIATE_PASSWORD_RESET_ERROR';

// Helper
var getDecodedValueIfString = function getDecodedValueIfString(data) {
  return function (acc, key) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, key, typeof data[key] === 'string' ? (0, _cicUtils.decodeEntities)(data[key]) : data[key]));
  };
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  switch (action.type) {
    case LOAD_ACCOUNT_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: Object.keys(action.data.innerData).reduce(getDecodedValueIfString(action.data.innerData), {})
      });
    case SAVE_ACCOUNT_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: Object.keys(action.data.innerData).reduce(getDecodedValueIfString(action.data.innerData), {})
      });
    case INITIATE_PASSWORD_RESET:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: true
      });
    case INITIATE_PASSWORD_RESET_DONE:
      return _objectSpread(_objectSpread({}, state), {}, {
        isRequestPending: false,
        resetData: action.data
      });
    case INITIATE_PASSWORD_RESET_ERROR:
      {
        // Only one errorcode is possible
        // When FIELD_CONTENT error only captcha could be wrong
        var err = action.data.error.response.data.errors.pop().code;
        var errorType = err === 'FIELD_CONTENT' ? "".concat(err, "_captcha") : err;
        return _objectSpread(_objectSpread({}, state), {}, {
          isRequestPending: false,
          error: errorType
        });
      }
    default:
      return state;
  }
}

// Action Creators
var initiatePasswordReset = exports.initiatePasswordReset = function initiatePasswordReset(dispatch, payload, config) {
  dispatch({
    type: INITIATE_PASSWORD_RESET
  });
  var rsp = (0, _accountDataApi.resetPasswordInitiate)(_objectSpread({}, payload), config);
  rsp.then(function (response) {
    if (response.status === 201) {
      dispatch({
        type: INITIATE_PASSWORD_RESET_DONE,
        data: {
          success: true
        }
      });
    }
  }).catch(function (err) {
    dispatch({
      type: INITIATE_PASSWORD_RESET_ERROR,
      data: {
        success: false,
        error: err
      }
    });
  });
  return rsp;
};
var loadCurrentAccountData = exports.loadCurrentAccountData = function loadCurrentAccountData(dispatch) {
  return (0, _accountDataApi.getAccountData)().then(function (response) {
    var loadedData = response && response.data;
    dispatch({
      type: LOAD_ACCOUNT_DATA,
      data: {
        innerData: loadedData
      }
    });
  });
};
var saveCurrentAccountData = exports.saveCurrentAccountData = function saveCurrentAccountData(dispatch, data) {
  return {}
  // saveAccountData(data)
  //   .then(() => {
  //     dispatch({
  //       type: SAVE_ACCOUNT_DATA,
  //       data: {
  //         innerData: CacheHandler.getCurrentCacheByToken('accountData'),
  //       },
  //     });
  //   })
  //   .catch((err) => {
  //     const error = err && err.data && err.data.errors;
  //     throw error;
  //   })
  ;
};